import React, { useState } from "react";
import { Icon } from "../components/icons";
import AttendanceCalendarView from "./AttendanceCalendarView";
import AttendanceListView from "./AttendanceListView";

const VIEW_KEY = "admin.attendance.view";

/** Toggle tampilan Kalender / List (pilihan diingat per browser). */
export function ViewToggle({ view, onChange }) {
  const opt = (key, IconC, title) => (
    <button
      onClick={() => onChange(key)}
      title={title}
      className={`h-8 w-8 inline-flex items-center justify-center rounded-full transition ${
        view === key ? "bg-brand-100 text-brand-700" : "text-slate-400 hover:text-slate-600"
      }`}
    >
      <IconC size={16} />
    </button>
  );
  return (
    <div className="inline-flex items-center gap-0.5 rounded-full bg-white border border-slate-200 p-0.5">
      {opt("calendar", Icon.Calendar, "Tampilan kalender")}
      {opt("list", Icon.Doc, "Tampilan list")}
    </div>
  );
}

/** Halaman Absensi admin: tampilan kalender (default) atau list. */
export default function AttendanceListPage() {
  const [view, setView] = useState(() => {
    try {
      return localStorage.getItem(VIEW_KEY) || "calendar";
    } catch {
      return "calendar";
    }
  });
  const changeView = (v) => {
    setView(v);
    try {
      localStorage.setItem(VIEW_KEY, v);
    } catch {}
  };
  const toggle = <ViewToggle view={view} onChange={changeView} />;
  return view === "list" ? <AttendanceListView toggle={toggle} /> : <AttendanceCalendarView toggle={toggle} />;
}
